module.exports = __webpack_public_path__ + "static/img/logo_01.57eca4f0.png";